import type { PaginationInstance } from "@/types";

/**
 * 分页基础数据实例工厂
 */
export const paginationInstanceFactory = (): PaginationInstance => ({
  pageSize: 15,
  pageNum: 1,
  totalCount: 0
});
